import React from 'react'

import { getShortenedDistance } from '../../../../../../utilities'
import useInterval from '../../../../../../hooks/useInterval'

type AgeProps = {
  date: Date
}

const Age: React.FC<AgeProps> = ({ date }) => {
  const [time, setTime] = React.useState(getShortenedDistance(date))

  useInterval(5000, () => setTime(getShortenedDistance(date)))

  return <>{time}</>
}

export default Age
